import Time from '@/utils/Time';
import { Home } from '@/routes';
// import API from '@/services/api';
import { connect } from 'react-redux';
import { useRecaptcha } from '@/hooks';
import FONTS from '@/assets/fonts.json';
// import { sentryDSN } from '@/utils/API';
import { User, MCD } from '@/services/app';

import { useState, useEffect } from 'react';
import { getLogged } from '@/redux/auth/selectors';
import type { UserState } from '@/redux/user/types';
import { getUserState } from '@/redux/user/selectors';
import { showConsole, isDEV } from '@/utils/Location';
import CloseButton from '@/components/CloseButton';
// import { RequestError } from '@CS/components/Popups';
import { Routes, Route, useLocation } from 'react-router-dom';
// import { withSentryReactRouterV6Routing } from '@sentry/react';
import { useFonts, useLoader } from '@/hooks';
import { WatermelonLoginChat } from '@/components/WatermelonLoginChat/WatermelonLoginChat.tsx';

type ApplicationProps = {
  logged?: boolean;
  login?: boolean;
  user: UserState;
};

const Application = ({ user, /* logged, */ login = true }: ApplicationProps) => {
  const { search } = useLocation();
  const fontsLoaded = useFonts(FONTS);

  // const network = useNetworkListener();
  const { recaptcha } = useRecaptcha();
  const onLoad = () => setLoading(false);

  const [loading, setLoading] = useState(true);
  // const cancelLogin = () => setLoginError(void 0);
  const { email, points, /* country, */  readonlyData } = user ?? {};

  const loader = useLoader(loading || !recaptcha || !fontsLoaded);
  // const [loginError, setLoginError] = useState<RequestErrorInfo>();

  const toggleFullscreen = () =>
    !isDEV() && ~MCD.toggleFullscreen() && MCD.orientationScreen();

  const onVisibilityChange = () =>
    document.visibilityState === 'visible' && toggleFullscreen();

  const getUserData = () =>
    Promise.all([
      User.checkUserPoints(), 
      User.checkUserData(), 
      User.checkRedeemedOffers(),
  ]);

  const handleAuth = () =>
    (!email || typeof points !== 'number') &&
    getUserData()
      .then(onLoad)
      // .catch(loginRedirect);
      .catch(() => console.log('handleAuth error'));

  const initApplication = () => {
    // API.revokeToken();
    toggleFullscreen();
    User.checkUserCountry();
    User.checkUserLanguage();
    login ? handleAuth() : onLoad();
  };

  // const loginRedirect = () => {
  //   setLoading(false);
  //   navigate('/login');
  // };
  //
  // const onLogin = async () => {
  //   toggleFullscreen();
  //   await getUserData();
  //   setLoading(false);
  //   navigate('/');
  // };

  // useEffect(() => {
  //   const userInfo = country && email;
  //   const ready = recaptcha && !logged;
  //
  //   ready &&
  //     userInfo &&
  //     API.login(user).catch(error =>
  //       setLoginError(API.getRequestErrorInfo(error))
  //     );
  // }, [recaptcha, country, logged, email, user]);

  useEffect(() => {
    showConsole((readonlyData as { console?: boolean })?.console);
  }, [readonlyData]);

  useEffect(() => {
    MCD.App.mcd && !loading && initApplication();
  }, [MCD.App.mcd]);

  useEffect(() => {
    Time.setCurrentTime(search);
  }, [search]);

  useEffect(() => {
    document.addEventListener('visibilitychange', onVisibilityChange);
    document.addEventListener('mcdBridgeReady', initApplication);
    (MCD.App.mcd || isDEV()) && initApplication();

    return () => {
      document.removeEventListener('mcdBridgeReady', initApplication);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  /**
   * Sentry Tracing Routes Wrapper:
   *
  const RoutesWrapper = sentryDSN
    ? withSentryReactRouterV6Routing(Routes)
    : Routes; */

  return (
    loader ||
    // network ||
    (
      <>
        <WatermelonLoginChat language={user.language || 'en'} />

        <CloseButton onClick={MCD.openHome} />

        <Routes>
          {/* <RoutesWrapper> */}
          <Route path="/" element={<Home />} />
          {/* </RoutesWrapper> */}
        </Routes>

        {/*{loginError && <RequestError info={loginError} onClose={cancelLogin} />}*/}
      </>
    )
  );
};

const mapStateToProps = (state: never) => ({
  user: getUserState(state),
  logged: getLogged(state)
});

export default connect(mapStateToProps)(Application);
